import DataService from './dataService'
import { IAccountService } from "../interfaces/iAccountService";

export class AccountService extends DataService implements IAccountService {
  constructor() {
    super('/account/');
  }

  login(data: object): JQuery.jqXHR<any> {
    return this.post('login', data);
    }

  logout(): JQuery.jqXHR<any> {
    return this.get('logout').done(() => {
      //window.location.href = "/";
    });
    }

    resetPassword(data: object): JQuery.jqXHR<any> {
        return this.post('resetPassword', data);
    }

    loginWithToken(data: object): JQuery.jqXHR<any> {
        return this.post('loginWithToken', data);
    }

    register(data: object): JQuery.jqXHR<any> {
        return this.post('register', data);
    }
}



// WEBPACK FOOTER //
// ./static-content/services/client/classes/accountService.ts